import React from "react";

import styles from './InstructionStep.module.css'

type TInstructionStep = {
  label: string,
  title: string,
  imgSrc: string,
  instruction: string,
}

const InstructionStep: React.FC<TInstructionStep> = ({ label, title, imgSrc, instruction }) => {
  return (
    <div className={styles.wrapper}>
      <div>
        <div className={styles.label}>{label}</div>
        <div className={styles.title}>{title}</div>
        <div className={styles.instruction}>{instruction}</div>
      </div>
      <img alt="Step" src={imgSrc} className={styles.img}></img>
    </div>
  );
}

export default InstructionStep;